module.exports = __webpack_public_path__ + "static/media/laughingSalPatch01.cab1b4d1.jpeg";